"use client";

import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { normalizeLanguage, persistLanguage } from "@/i18n/settings";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation("admin");
  const currentLanguage = normalizeLanguage(
    i18n.resolvedLanguage ?? i18n.language,
  );
  const nextLanguage = currentLanguage === "ar" ? "en" : "ar";

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      aria-label={
        nextLanguage === "ar"
          ? t("language.switchToArabic")
          : t("language.switchToEnglish")
      }
      onClick={() => {
        persistLanguage(nextLanguage);
        void i18n.changeLanguage(nextLanguage);
      }}
      className="h-9 gap-1.5 rounded-full px-3"
    >
      <Languages className="size-4" />
      <span className="text-xs font-semibold uppercase">{nextLanguage}</span>
    </Button>
  );
}
